import './Pages.css';
import '../css/navbarchap.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import {useEffect} from "react";
import PDFViewerComponent from '../components/PDFViewerComponent';
import Container from 'react-bootstrap/Container';
import { useNavigate } from 'react-router-dom';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';

const Chapitre1partA = () => {
    useEffect(() => {
        document.body.classList.add('no-scroll'); // Ajoutez la classe no-scroll au body
        return () => {
          document.body.classList.remove('no-scroll'); // Retirez la classe no-scroll du body lorsque le composant est démonté
        };
      }, []);

const navigate = useNavigate();

    return (
      <div className="Chapitre">
        <Navbar expand="lg">
            <Container>
            <Navbar.Toggle aria-controls="basic-navbar-nav">
                <span className='navbar-toggler-nav'></span>
            </Navbar.Toggle>
            <Navbar.Collapse id="basic-navbar-nav">
                <Nav className="mx-auto">
                <Nav.Link href="" className={'navbar-link'} onClick={() => navigate('/repereschrono')}>Chapitre précédent
                      <div className="small-italic">Repères chronologiques</div>
                    </Nav.Link>
                    <Nav.Link href="#sommaire" className={'navbar-link'} onClick={() => navigate('/')}>Retour au sommaire
                      <div className="small-italic">Chapitre 1 - André Bach: Sa famille,<br />ses quatres femmes et ses deux filles</div>
                    </Nav.Link>
                    <Nav.Link href="" className={'navbar-link'} onClick={() => navigate('/chapitre1partb')}>Chapitre suivant
                      <div className="small-italic">B.  Ses quatre femmes et<br />le cinéaste Georges Méliès</div>
                    </Nav.Link>
                </Nav>
            </Navbar.Collapse>
            </Container>
        </Navbar>
          <div className="PDF-viewer-container">
			      <PDFViewerComponent
				      document={`${process.env.PUBLIC_URL}chapitre1parta.pdf`}
			      />
		    </div>
      </div>
    );
  };
export default Chapitre1partA;
  

